<!--
 @description 应用交付-发布概览页
 @author xiehan
 @date 2018/10/16
-->
<template>
    <div class="releaseOverview__content">
      <g-back :history="history" class="ilb"></g-back>
      <div class="ilb ml-base" v-show="releaseInfo.status === '1'">
          <el-button type="danger" 
            @click="killProcess"
            class="ml-base"
            v-g-rac="gRac('releaseOverview@killProcess')" 
            v-text="$t('appDelivery.killProcess')"></el-button>
      </div>
      <div class="ilb ml-base" v-show="releaseInfo.status === '3' || releaseInfo.status === '4'">
        <el-button type="primary" 
          @click="confirmVisible = true"
          class="ml-base"
          v-g-rac="gRac('releaseOverview@rePublish')" 
          v-text="$t('appDelivery.rePublish')"></el-button>
      </div>
      <div class="releaseinfo-wrap">
        <el-row>
          <el-col :span="12">
            <span v-text="$t('appDelivery.operations') + '：'"></span><span v-text="releaseInfo.operations"></span>
          </el-col>
          <el-col :span="12">
            <span v-text="$t('appDelivery.cluster') + '：'"></span><span v-text="releaseInfo.clusterName"></span>
          </el-col>
        </el-row>
        <el-row class="mt-base">
          <el-col :span="12">
            <span v-text="$t('appDelivery.develop') + '：'"></span><span v-text="releaseInfo.developer"></span>
          </el-col>
          <el-col :span="12">
            <span v-text="$t('appDelivery.host') + '：'"></span><span v-text="releaseInfo.machineCnt + $t('appDelivery.machineUnit')"></span>
          </el-col>
        </el-row>
        <el-row class="mt-base mb-base">
          <el-col :span="12">
            <span v-text="$t('appDelivery.test') + '：'"></span><span v-text="releaseInfo.tester"></span>
          </el-col>
          <el-col :span="12">
            <span v-text="$t('appDelivery.resource') + '：'"></span><span v-text="releaseInfo.versionCnt + $t('appDelivery.packageUnit')"></span>
          </el-col>
        </el-row>
        <div class="split-line"></div>
        <el-row class="mt-base">
          <el-col :span="12">
            <span v-text="$t('appDelivery.appName') + '：'"></span><span v-text="releaseInfo.appName"></span>
          </el-col>
          <el-col :span="12">
            <span v-text="$t('appDelivery.deployStrategy') + '：'"></span>
            <span v-text="strategyText"
                :class="{ 'strategy-btn' : releaseInfo.status === '0' }"
                @click="openStrategy"></span>
          </el-col>
        </el-row>
        <el-row class="mt-base">
          <el-col :span="12">
            <span v-text="$t('appDelivery.version') + '：'"></span><span v-text="releaseInfo.version"></span>
          </el-col>
          <el-col :span="12">
            <span v-text="$t('appDelivery.installWay') + '：'"></span><span v-text="select_install[releaseInfo.upgradeType]"></span>
          </el-col>
        </el-row>
        <el-row class="mt-base">
          <el-col :span="12">
            <span v-text="$t('appDelivery.deployPath') + '：'"></span><span v-text="releaseInfo.deployPath"></span>
          </el-col>
          <el-col :span="12">
            <span v-text="$t('appDelivery.scriptPath') + '：'"></span><span v-text="releaseInfo.scriptPath"></span>
          </el-col>
        </el-row>
        <el-row class="mt-base mb-base">
          <el-col :span="12">
            <span v-text="$t('appDelivery.status') + '：'"></span>
            <span v-text="select_delivery[releaseInfo.status]"
              :class="{ 'strategy-btn' : releaseInfo.status === '3' }"
              @click="jumpToAbort"></span>
          </el-col>
        </el-row>
        <div v-show="releaseInfo.status === '0'" style="margin-bottom: 10px;">
          <el-button type="primary" 
            @click="deleteRelease"
            v-g-rac="gRac('releaseOverview@delete')" 
            v-text="$t('common.delete')"></el-button>
          <el-button type="primary" 
            @click="confirmVisible = true"
            class="ml-base"
            v-g-rac="gRac('releaseOverview@publish')" 
            v-text="$t('appDelivery.publish')"></el-button>
        </div>
        <div v-show="releaseInfo.status === '0'">
          <div v-text="$t('appDelivery.confirmConfig')" style="color: rgb(0, 18, 255); margin-bottom: 10px;"></div>
          <el-table
            :data="diffTableData"
            style="width: 100%">
            <el-table-column
              prop="key"
              :label="$t('appDelivery.diffTable.key')">
            </el-table-column>
            <el-table-column
              prop="dir"
              :label="$t('appDelivery.diffTable.dir')">
            </el-table-column>
            <el-table-column
              fixed="right"
              :label="$t('appDelivery.diffTable.result')">
              <template slot-scope="scope">
                <el-button 
                  @click="diffClick(scope.row)" 
                  type="text" 
                  size="small"
                  :class="{'unclick': scope.row.result !== $t('appDelivery.diff') }"
                  v-text="scope.row.result"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-table-extend
          v-show="releaseInfo.status !== '0'"
          :cell-style="cellStyle"
          :cell-click="cellClick"
          :data="tableData"
          :head="tableHead"
          :currentChange="currentChange"
          :sizeChange="sizeChange"
          border>
        </el-table-extend>
        <!-- 部署策略弹窗 -->
        <el-dialog :closeOnClickModal="false"
          :title="$t('appDelivery.deployStrategy')"
          :visible.sync="strategyVisible"
          width="400px">
          <el-row class="mb-base" v-show="releaseInfo.upgradeType === '2'">
            <div v-text="$t('appDelivery.upgradeOption')"></div>
            <el-col :span="8"><el-checkbox v-model="tactics.beforeUpgrade">{{ $t('appDelivery.beforeUpgrade') }}</el-checkbox></el-col>
            <el-col :span="8"><el-checkbox v-model="tactics.afterUpgrade">{{ $t('appDelivery.afterUpgrade') }}</el-checkbox></el-col>
          </el-row>
          <el-row class="mb-base" v-show="releaseInfo.upgradeType === '1'">
            <div v-text="$t('appDelivery.installOption')"></div>
            <el-checkbox v-model="tactics.afterInstall">{{ $t('appDelivery.afterInstall') }}</el-checkbox>
          </el-row>
          <el-row>
            <div v-text="$t('appDelivery.releaseOption')"></div>
            <el-checkbox v-model="tactics.afterRelease">{{ $t('appDelivery.afterRelease') }}</el-checkbox>
          </el-row>
          <span slot="footer" class="dialog-footer">
            <el-button @click="strategyVisible = false" v-text="$t('common.cancel')"></el-button>
            <el-button type="primary" @click="confirmTactics" v-text="$t('common.confirm')"></el-button>
          </span>
        </el-dialog>
        <!-- 日志弹窗 -->
        <el-dialog :closeOnClickModal="false"
          :title="$t('common.detail')"
          :visible.sync="logVisible"
          width="600px">
          <el-row class="mb-base">
            <el-col :span="12">
              <span v-text="$t('appDelivery.table.packageName') + '：'"></span>
              <span v-text="hostDetail.packageName"></span>
            </el-col>
            <el-col :span="12">
              <span v-text="$t('appDelivery.table.oriVersion') + '：'"></span>
              <span v-text="hostDetail.oriVersion"></span>
            </el-col>
          </el-row>
          <el-row class="mb-base">
            <el-col :span="12">
              <span v-text="$t('appDelivery.table.host') + '：'"></span>
              <span v-text="hostDetail.host"></span>
            </el-col>
            <el-col :span="12">
              <span v-text="$t('appDelivery.table.targetVersion') + '：'"></span>
              <span v-text="hostDetail.targetVersion"></span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <span v-text="$t('appDelivery.table.deployPath') + '：'"></span>
              <span v-text="hostDetail.deployPath"></span>
            </el-col>
          </el-row>
          <!-- 进度 -->
          <div class="progress-line ilb mt-base"
            v-for="(item, index) in hostDetail.scheduleBar"
            :key="item.key"
            :class="{'line-after-none' : index === hostDetail.scheduleBar.length - 1,
            'line-background-before-wait' : item.status === 0,
            'line-background-after-wait' : item.status === 0,
            'line-background-before-error': item.status === 2,
            'line-background-after-error': item.status === 2}">
            <i class="icon iconfont"
              :class="{'icon-duigou' : item.status !== 2,
              'icon-amc_circle_close': item.status === 2,
              'color-grey' : item.status === 0,
              'color-red' : item.status === 2}"></i>
            <span class="progress-text" v-text="item.name"></span>
          </div>
          <!-- 日志 -->
          <div class="mt-base logs-wrap">
            <div v-text="$t('appDelivery.logs') + '：'"></div>
            <div v-show="releaseInfo.status !== '4'">
              <div class="ilb" v-show="releaseLog.length > 0">
                <div v-for="(item, index) in releaseLog" :key="index" v-text="item"></div>
              </div>
              <el-button type="primary" class="loading-btn" :loading="true" v-show="logStatus === 0 && logTimes < 300"></el-button>
              <div v-text="$t('appDelivery.logOutOfTime')" v-show="logTimes === 300"></div>
            </div>
            <div v-show="releaseInfo.status === '4'" v-text="$t('common.none')"></div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="logVisible = false" v-text="$t('common.close')"></el-button>
          </span>
        </el-dialog>
        <!-- 检查文件是否不一致弹窗 -->
        <el-dialog :closeOnClickModal="false"
          :title="$t('appDelivery.checkCenter')"
          :visible.sync="diffVisible"
          width="800px">
          <div id="cm-view"></div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="diffVisible = false" v-text="$t('common.close')"></el-button>
          </span>
        </el-dialog>
        <!-- 确认发布弹窗 -->
        <el-dialog :closeOnClickModal="false"
          :title="$t('appDelivery.releaseConfirm')"
          :visible.sync="confirmVisible"
          width="400px">
          <div>
            <div class="mb-base">
              <span v-text="$t('appDelivery.confirmTips1')"></span>
              <span v-text="releaseInfo.siteLength"></span>
              <span v-text="$t('appDelivery.confirmTips2')"></span>
            </div>
            <div v-for="(val, key) in releaseInfo.siteInfo" :key="key">
              <span v-text="key"></span>：
              <span v-for="item in val" :key="item" v-text="item + ' '"></span>
            </div>
            <div class="mt-base">
              <span v-text="$t('appDelivery.confirmTips3')"></span>
              <span v-text="releaseInfo.siteLength"></span>
              <span v-text="$t('appDelivery.confirmTips4')"></span>
            </div>
            <div></div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="confirmVisible = false" v-text="$t('common.close')"></el-button>
            <el-button type="primary" @click="confirmPublish" v-text="$t('common.confirm')"></el-button>
          </span>
        </el-dialog>
      </div>
    </div>
</template>

<script>
  import 'codemirror/addon/merge/merge.js'
  import 'codemirror/addon/merge/merge.css'
  import DiffMatchPatch from 'diff-match-patch'

  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import appDeliveryBiz from '@/logic/continuousDelivery/appDeliveryBiz'

  window.diff_match_patch = DiffMatchPatch
  window.DIFF_DELETE = -1
  window.DIFF_INSERT = 1
  window.DIFF_EQUAL = 0
  const LOG_INTERVAL = 5000
  export default {
    mixins: [rac, dic],
    data () {
      return {
        history: [],
        releaseInfo: {},
        select_install: {},
        select_delivery: {},
        select_site: {},
        currentPage: 1,
        perPageCount: 10,
        tableData: {},
        tableHead: [],
        strategyVisible: false,
        logVisible: false,
        strategyText: this.$t('common.none'),
        tactics: {
          beforeUpgrade: false,
          afterUpgrade: false,
          afterInstall: false,
          afterRelease: false
        },
        hostDetail: {},
        processTimer: null,
        logTimer: null,
        logStatus: 0,
        logTimes: 0,
        releaseLog: [],
        diffTableData: [],
        diffVisible: false,
        confirmVisible: false
      }
    },
    methods: {
      init () {
        this.getReleaseInfo()
        this.setHistory()
        this.waitInstallWay()
        this.waitSiteList()
        this.waitDeliveryStatus()
        this.confirmVisible = false
      },
      setHistory () {
        this.history = []
        this.history.push({ name: this.$t('appDelivery.releaseOverview') })
      },
      async waitInstallWay () {
        await this.dGetDictionaryByCode('appPackageType')
        this.select_install = { ...this.dDictionary.appPackageType }
      },
      async waitSiteList () {
        await this.dGetDictionaryByCode('remoteconfig')
        this.select_site = { ...this.dDictionary.remoteconfig }
      },
      async waitDeliveryStatus () {
        await this.dGetDictionaryByCode('deliverystatus')
        this.select_delivery = { ...this.dDictionary.deliverystatus }
        this.getReleaseHost()
      },
      deleteRelease () {
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          appDeliveryBiz.deleteDelivery({ id: this.$route.query.id }).then(() => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            this.$router.push({ name: 'appDelivery' })
          })
        }).catch(() => {})
      },
      confirmPublish () {
        this.releaseInfo.status === '0' ? this.publish() : this.rePublish()
      },
      publish () {
        appDeliveryBiz.publishDelivery({ id: this.$route.query.id }).then(() => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          this.init()
        }).catch((e) => {
          console.warn(e)
        })
      },
      killProcess () {
        appDeliveryBiz.killProcess({ id: this.$route.query.id }).then(() => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          this.init()
        }).catch((e) => {
          console.warn(e)
        })
      },
      rePublish () {
        appDeliveryBiz.rePublish({ id: this.$route.query.id }).then(() => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          this.init()
        }).catch((e) => {
          console.warn(e)
        })
      },
      openStrategy () {
        if (this.releaseInfo.status !== '0') return
        this.strategyVisible = true
      },
      confirmTactics () {
        appDeliveryBiz.updateTactics({
          id: this.$route.query.id,
          beforeUpgrade: this.tactics.beforeUpgrade,
          afterUpgrade: this.tactics.afterUpgrade,
          afterInstall: this.tactics.afterInstall,
          afterRelease: this.tactics.afterRelease
        }).then(() => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          this.strategyVisible = false
          this.setStrategyText()
        })
      },
      setStrategyText () {
        let beforeUpgradeText = this.tactics.beforeUpgrade ? this.$t('appDelivery.beforeUpgrade') : ''
        let afterUpgradeText = this.tactics.afterUpgrade ? this.$t('appDelivery.afterUpgrade') : ''
        let afterInstallText = this.tactics.afterInstall ? this.$t('appDelivery.afterInstall') : ''
        let afterReleaseText = this.tactics.afterRelease ? this.$t('appDelivery.afterRelease') : ''
        let text = (this.tactics.beforeUpgrade || this.tactics.afterUpgrade || this.tactics.afterInstall || this.tactics.afterRelease)
          ? [beforeUpgradeText, afterUpgradeText, afterInstallText, afterReleaseText].filter((item) => {
            return item !== ''
          }).join('、') : this.$t('common.none')
        this.strategyText = text
      },
      jumpToAbort () {
        if (this.releaseInfo.status !== '3') return
        this.$router.push({ name: 'deliveryAbort', query: { id: this.$route.query.id } })
      },
      getReleaseInfo () {
        appDeliveryBiz.getDeliveryById({ id: this.$route.query.id }).then((data) => {
          this.releaseInfo = data
          this.releaseInfo.siteLength = Object.keys(this.releaseInfo.siteInfo).length
          if (this.releaseInfo.status === '0') {
            this.getConfigCheck()
          }
          if (this.releaseInfo.tactics && Object.keys(this.releaseInfo.tactics).length > 0) {
            this.tactics = this.releaseInfo.tactics
          } else {
            for (let i in this.tactics) {
              this.tactics[i] = false
            }
          }
          this.setStrategyText()
        })
      },
      getConfigCheck () {
        this.diffTableData = []
        appDeliveryBiz.getConfigCheck({ id: this.$route.query.id }).then(data => {
          let arr = []
          data.map(item => {
            switch (item.result) {
              case '1':
                item.result = this.$t('appDelivery.same')
                break
              case '2':
                item.result = this.$t('appDelivery.diff')
                break
              case '3':
                item.result = this.$t('appDelivery.noneFile')
                break
            }
            arr.push(item)
          })
          this.diffTableData = arr
        })
      },
      diffClick (rowInfo) {
        if (rowInfo.result === this.$t('appDelivery.diff')) {
          this.uclConfValue = rowInfo.uclConfValue
          this.diffVisible = true
          this.$nextTick(() => {
            let target = document.getElementById('cm-view')
            target.innerHTML = ''
            CodeMirror.MergeView(target, {
              value: rowInfo.uclConfValue,
              origLeft: null,
              orig: rowInfo.packageConfValue,
              lineNumbers: true,
              highlightDifferences: true,
              connect: 'align',
              readOnly: true
            })
          })
        }
      },
      getReleaseHost () {
        let searchObj = {
          currentPage: this.currentPage,
          perPageCount: this.perPageCount,
          id: this.$route.query.id
        }
        appDeliveryBiz.getReleaseHost(searchObj).then((data) => {
          this.tableData = data
          this.tableHead = [
            { key: 'host', label: this.$t('appDelivery.table.host'), showOverflowTooltip: true },
            { key: 'appName', label: this.$t('appDelivery.table.appName'), showOverflowTooltip: true },
            { key: 'packageName', label: this.$t('appDelivery.table.packageName'), showOverflowTooltip: true },
            { key: 'deployPath', label: this.$t('appDelivery.table.deployPath'), showOverflowTooltip: true },
            { key: 'oriVersion', label: this.$t('appDelivery.table.oriVersion'), showOverflowTooltip: true },
            { key: 'targetVersion', label: this.$t('appDelivery.table.targetVersion'), showOverflowTooltip: true },
            { key: 'schedule',
              label: this.$t('appDelivery.table.schedule'),
              showOverflowTooltip: true,
              formatter: 'Dictionary',
              formatterDic: this.select_delivery }
          ]
        })
      },
      cellStyle ({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 0) {
          return 'color:#0B8DE5; cursor:pointer'
        }
      },
      currentChange (val) {
        this.currentPage = val
        this.getReleaseHost()
      },
      getProcess (id) {
        appDeliveryBiz.getPublishProgress({ id: id }).then((data) => {
          this.hostDetail = data
        })
      },
      setProcessTimer (id) {
        this.getProcess(id)
        clearTimeout(this.processTimer)
        this.processTimer = null
        this.processTimer = setTimeout(() => {
          if (this.logStatus === 0 && this.logTimes < 300 && this.releaseInfo.status !== '4') {
            this.setProcessTimer(id)
          }
        }, LOG_INTERVAL)
      },
      setLogsTimer (pointer, host) {
        if (this.logStatus === 1 || this.logTimes >= 300) return
        clearTimeout(this.logTimer)
        this.logTimer = null
        appDeliveryBiz.getDeliveryLog({ pointer: pointer, host: host, id: this.$route.query.id }).then((data) => {
          if (data.logs && data.logs.length > 0) {
            data.logs.map((item) => {
              this.releaseLog.push(item)
            })
          }
          this.logStatus = data.status
          if (this.logStatus === 1 && this.releaseInfo.status === '1') {
            this.init()
          }
          this.logTimes += (LOG_INTERVAL / 1000)
          this.logTimer = setTimeout(() => {
            this.setLogsTimer(data.pointer, host)
          }, LOG_INTERVAL)
        })
      },
      cellClick (row, columnKey) {
        if (columnKey === 'host') {
          this.releaseLog = []
          this.logStatus = 0
          this.logTimes = 0
          this.setProcessTimer(row.id)
          this.setLogsTimer(0, row.host)
          this.logVisible = true
        }
      },
      sizeChange (val) {
        this.currentPage = 1
        this.perPageCount = val
        this.getReleaseHost()
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'releaseOverview' && from.name === 'appDelivery') {
          this.init()
        }
      },
      logVisible (val) {
        if (!val) {
          clearTimeout(this.processTimer)
          this.processTimer = null
          clearTimeout(this.logTimer)
          this.logTimer = null
        }
      }
    },
    mounted () {
      this.init()
    }
  }
</script>

<style scoped>
  .releaseinfo-wrap {
    width: 840px;
    padding: 0 20px;
    font-size: 14px;
  }
  .split-line {
    width: 100%;
    height: 20px;
    text-align: center;
    color: rgba(0, 0, 0, 0.65);;
    line-height: 20px;
    position: relative;
  }
  .split-line:after {
    content: "";
    width: 100%;
    height: 1px;
    position: absolute;
    bottom: 50%;
    z-index: 1;
    background: #ddd;
    left: 0;
  }
  .strategy-btn {
    color: #0B8DE5;
    cursor: pointer;
  }
  .progress-line {
    width: fit-content;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    color: rgba(0, 0, 0, 0.65);;
    height: 50px;
    padding: 0 10px;
    text-align: center;
    position: relative;
  }
  .progress-line:before {
    content: "";
    background: #1ed045;
    width: 50%;
    height: 2px;
    position: absolute;
    top: 10px;
    left: 0;
    z-index: 1;
  }
  .progress-line:after {
    content: "";
    background: #1ed045;
    width: 50%;
    height: 2px;
    position: absolute;
    top: 10px;
    left: 50%;
    z-index: 1;
  }
  .line-before-none:before {
    content: "";
    display: none;
  }
  .line-after-none:after {
    content: "";
    display: none;
  }
  .line-background-before-error:before {
    background: #ff0000;
  }
  .line-background-after-error:after {
    background: #ff0000;
  }
  .line-background-before-wait:before {
    background: #adadad;
  }
  .line-background-after-wait:after {
    background: #adadad;
  }
  .progress-text {
    position: relative;
    top: 30px;
  }
  .progress-line .iconfont {
    color: #1ed045;
    background: #fff;
    font-size: 22px;
    position: absolute;
    bottom: 26px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 9;
  }
  .color-red {
    color: #ff0000 !important;
  }
  .color-grey {
    color: #adadad !important;
  }
  .logs-wrap {
    max-height: 300px;
    overflow-y: auto;
  }
  .loading-btn {
    color: #000;
    background: #fff;
    border: none;
    font-size: 20px;
    display: block;
  }
  .unclick {
    color: rgba(0, 0, 0, 0.65);
  }
</style>